module.exports = __webpack_public_path__ + "images/a58b7712.png";